/**
 * Chave de idempotencia dos creates do MedHunter Manual (r6-18, R1).
 *
 * Uma chave por ABERTURA do modal: dois cliques, um retry do aluno ou um "Replay XHR"
 * mandam a mesma chave, e o backend devolve o registro ja criado em vez de gravar outro.
 * O header e lido por `IdempotentRequest` no `ManualEntriesController`.
 */
import { IDEMPOTENT_IN_PROGRESS_CODE } from '@/types/api'

export const IDEMPOTENCY_HEADER = 'Idempotency-Key'

/** Texto do 409 `idempotent_in_progress`: a primeira chamada ainda esta rodando. */
export const IDEMPOTENT_IN_PROGRESS_MESSAGE = 'Ainda salvando o registro anterior, aguarde.'

/**
 * Mensagem de erro de um envio do Manual (R2). O 409 em andamento pede espera, nao
 * correcao; qualquer outro erro mostra o texto do servidor, ou o `fallback`.
 * Checa `code` estruturalmente para nao importar `ApiError` de `api.ts` (que importa este).
 */
export function saveErrorMessage(error: unknown, fallback: string): string {
  const code = (error as { code?: unknown } | null)?.code
  if (code === IDEMPOTENT_IN_PROGRESS_CODE) return IDEMPOTENT_IN_PROGRESS_MESSAGE
  return error instanceof Error && error.message ? error.message : fallback
}

/**
 * UUID v4. `crypto.randomUUID` so existe em contexto seguro (https ou localhost); num
 * host http qualquer cai no fallback com `getRandomValues` ou, em ultimo caso,
 * `Math.random` — a chave so precisa ser unica por usuario durante 24h.
 */
export function newIdempotencyKey(): string {
  const cryptoApi = globalThis.crypto as Crypto | undefined
  if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
    return cryptoApi.randomUUID()
  }
  return uuidV4From(randomBytes(cryptoApi))
}

function randomBytes(cryptoApi: Crypto | undefined): Uint8Array {
  const bytes = new Uint8Array(16)
  if (cryptoApi && typeof cryptoApi.getRandomValues === 'function') {
    return cryptoApi.getRandomValues(bytes)
  }
  return bytes.map(() => Math.floor(Math.random() * 256))
}

function uuidV4From(source: Uint8Array): string {
  // Bits de versao (4) e de variante (10xx), como manda a RFC 4122.
  const bytes = Uint8Array.from(source)
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
